import Sidemenu from "../../components/sidemenu";
import { useState, useEffect } from "react";
import * as Styled from './Styled';
import Dropdown from '../../components/elements/dropdown';
import { functionService } from "../../lib/functions";


const CLM = () => {
    const [skillsList, setSkillsList] = useState([]);
    const [templatesList, setTemplatesList] = useState([]);
    const [selectedSkillName, setSelectedSkillName] = useState('');
    const [selectedSkillId, setSelectedSkillId] = useState(null);
    const [selectedTemplateName, setSelectedTemplateName] = useState('');
    const [selectedTemplateId, setSelectedTemplateId] = useState(null);
    const [message, setMessage] = useState('');

    useEffect(()=> {
        functionService.get("clm/skills").then(res => setSkillsList(res?.response?.data?.data));
        functionService.get("clm/templates").then(res => setTemplatesList(res?.response?.data?.data));
    },[])

    const selectSkill = (skillname, skillId) => {
        console.log(skillname,skillId);
        setSelectedSkillId(skillId);
        setSelectedSkillName(skillname);
    }

    const selectTemplate = (templatename, templateId) => {
        setSelectedTemplateName(templatename);
        setSelectedTemplateId(templateId);
    }

    const sendEmails = () => {
        setMessage('');
        // console.log('=======================================>')
        functionService.post('clm/sendBulkTemplateEmails', 
        { master_skill_id: selectedSkillId, 
          template_id: selectedTemplateId, 
          TemplateName: selectedTemplateName, 
          test: false
        }).then(res => {
            if(!res.status)
                setMessage(res.error.response.data.meta.message || 'Error while starting campaign!!');
            else
                setMessage(res.response.data.meta.message || 'Campaign Started')
        });
    }

    const sendTestEmail = () => {
        setMessage('');
        // console.log('=======================================>')
        functionService.post('clm/sendBulkTemplateEmails', 
        { master_skill_id: selectedSkillId, 
          template_id: selectedTemplateId, 
          TemplateName: selectedTemplateName, 
          test : true
        }).then(res => {
            if(!res.status)
                setMessage(res.error.response.data.meta.message || 'Error while starting campaign!!');
            else
                setMessage(res.response.data.meta.message || 'Campaign Started')
        });
    }

    const TestTemplate = () => {
        // console.log('=======================================>')
        functionService.post('clm/sendTemplateEmails', { template_id: selectedTemplateId });
    }



    return (
        <Styled.MainDiv>
            <Sidemenu />
            <Styled.CLMWrap>
                <Styled.Header>Email Management</Styled.Header>
                <Styled.CLMContent>
                    <Styled.InputWrap>
                        <Styled.InputTitleDiv>Skill</Styled.InputTitleDiv>
                        <Dropdown 
                            title="Select Skill"  
                            list={skillsList} 
                            value="id" 
                            name="name" 
                            selected={selectSkill} 
                            width="600px" 
                            height="55px" 
                            option="name" 
                            active={selectedSkillName} 
                        />
                    </Styled.InputWrap>
                    <Styled.InputWrap>
                        <Styled.InputTitleDiv>Email Template</Styled.InputTitleDiv>
                        <Dropdown 
                            title="Select Template"  
                            list={templatesList} 
                            value="id" 
                            name="name" 
                            selected={selectTemplate} 
                            width="600px" 
                            height="55px" 
                            option="name" 
                            active={selectedTemplateName} 
                        />
                    </Styled.InputWrap>
                    <Styled.ButtonWrap>
                        <Styled.Button onClick={TestTemplate} disabled = {selectedTemplateId === null} style={{marginRight: '10px'}}>Test Template</Styled.Button>
                        <Styled.Button onClick={sendTestEmail} disabled = {selectedTemplateId === null} style={{marginRight: '10px'}}>Test Email</Styled.Button>
                        <Styled.Button onClick={sendEmails} disabled = {selectedTemplateId === null}>Send Emails</Styled.Button>
                    </Styled.ButtonWrap>
                </Styled.CLMContent>
                <Styled.Footer>
                    <p>{message}</p>
                </Styled.Footer>
            </Styled.CLMWrap>
        </Styled.MainDiv>
    )
}

export default CLM;